import { useQuery } from '@tanstack/react-query';
import { selectedOfficeService } from '~/domain/SelectedOffice';
import type { IUser } from '~/models';
import { officeMissingInfoKeys } from './useOfficeCredentials';

interface IUseOfficeProfileArgs {
  /** The child office a parent picked inside the shift form (GOTU-14829). */
  officeId?: string | null;
  enabled: boolean;
}

/**
 * A child office's profile, read for the shift request's missing-info modal and PSA gate while the parent
 * stays the store's selected office. The store cannot be used: `useUserSelector` is the parent, and switching the selected office from
 * inside the wizard would move the whole app. Same read as `useGetSelectedOffice`, minus its dispatch.
 */
export const useOfficeProfile = ({ officeId, enabled }: IUseOfficeProfileArgs) =>
  useQuery<IUser>({
    queryKey: officeMissingInfoKeys.office(officeId),
    queryFn: () =>
      selectedOfficeService.getSelectedOffice({ officeId: officeId ?? undefined }) as Promise<IUser>,
    enabled: enabled && !!officeId,
  });
